// src/components/learning/placement/questions_abjad.js
// 15 questions test de placement — Niveau Abjad
// Structure réutilisable pour tous les niveaux

// Types de questions :
// 'reconnaitre_lettre'  → voir la lettre, choisir le bon nom
// 'trouver_lettre'      → voir le nom, choisir la bonne lettre
// 'localiser_son'       → voir un mot, trouver où est la lettre
// 'compter_syllabes'    → voir un mot, compter les syllabes

const QUESTIONS_ABJAD = [

  // ── BLOC 1 : Reconnaître la lettre (7 questions) ──────────────

  {
    id: 'q1',
    type: 'reconnaitre_lettre',
    niveau: 'Abjad',
    enonce: 'Comment s\'appelle cette lettre ?',
    lettre_affichee: 'ب',
    options: [
      { id: 'a', ar: 'الباء', fr: 'Ba', correct: true },
      { id: 'b', ar: 'النون', fr: 'Nun', correct: false },
      { id: 'c', ar: 'التاء', fr: 'Ta', correct: false },
      { id: 'd', ar: 'الياء', fr: 'Ya', correct: false },
    ]
  },

  {
    id: 'q2',
    type: 'reconnaitre_lettre',
    niveau: 'Abjad',
    enonce: 'Comment s\'appelle cette lettre ?',
    lettre_affichee: 'م',
    options: [
      { id: 'a', ar: 'الواو', fr: 'Waw', correct: false },
      { id: 'b', ar: 'الميم', fr: 'Mim', correct: true },
      { id: 'c', ar: 'الفاء', fr: 'Fa', correct: false },
      { id: 'd', ar: 'القاف', fr: 'Qaf', correct: false },
    ]
  },

  {
    id: 'q3',
    type: 'reconnaitre_lettre',
    niveau: 'Abjad',
    enonce: 'Comment s\'appelle cette lettre ?',
    lettre_affichee: 'س',
    options: [
      { id: 'a', ar: 'الشين', fr: 'Shin', correct: false },
      { id: 'b', ar: 'الصاد', fr: 'Sad', correct: false },
      { id: 'c', ar: 'السين', fr: 'Sin', correct: true },
      { id: 'd', ar: 'الزاي', fr: 'Zayn', correct: false },
    ]
  },

  {
    id: 'q4',
    type: 'reconnaitre_lettre',
    niveau: 'Abjad',
    enonce: 'Comment s\'appelle cette lettre ?',
    lettre_affichee: 'ع',
    options: [
      { id: 'a', ar: 'الغين', fr: 'Ghayn', correct: false },
      { id: 'b', ar: 'الحاء', fr: 'Ha', correct: false },
      { id: 'c', ar: 'الخاء', fr: 'Kha', correct: false },
      { id: 'd', ar: 'العين', fr: 'Ayn', correct: true },
    ]
  },

  {
    id: 'q5',
    type: 'trouver_lettre',
    niveau: 'Abjad',
    enonce: 'Quelle est la lettre الراء (Ra) ?',
    lettre_affichee: null,
    options: [
      { id: 'a', ar: 'ز', fr: 'Zayn', correct: false },
      { id: 'b', ar: 'ر', fr: 'Ra', correct: true },
      { id: 'c', ar: 'و', fr: 'Waw', correct: false },
      { id: 'd', ar: 'ن', fr: 'Nun', correct: false },
    ]
  },

  {
    id: 'q6',
    type: 'trouver_lettre',
    niveau: 'Abjad',
    enonce: 'Quelle est la lettre الضاد (Dad) ?',
    lettre_affichee: null,
    options: [
      { id: 'a', ar: 'ص', fr: 'Sad', correct: false },
      { id: 'b', ar: 'ط', fr: 'Ta emp.', correct: false },
      { id: 'c', ar: 'ض', fr: 'Dad', correct: true },
      { id: 'd', ar: 'ظ', fr: 'Dha emp.', correct: false },
    ]
  },

  {
    id: 'q7',
    type: 'trouver_lettre',
    niveau: 'Abjad',
    enonce: 'Quelle est la lettre الثاء (Tha) ?',
    lettre_affichee: null,
    options: [
      { id: 'a', ar: 'ب', fr: 'Ba', correct: false },
      { id: 'b', ar: 'ت', fr: 'Ta', correct: false },
      { id: 'c', ar: 'ث', fr: 'Tha', correct: true },
      { id: 'd', ar: 'ن', fr: 'Nun', correct: false },
    ]
  },

  // ── BLOC 2 : Trouver la lettre dans un mot (4 questions) ──────

  {
    id: 'q8',
    type: 'localiser_son',
    niveau: 'Abjad',
    enonce: 'Dans quel mot trouves-tu la lettre ب ?',
    lettre_cible: 'ب',
    options: [
      { id: 'a', ar: 'شَمْسٌ', fr: 'soleil', emoji: '☀️', correct: false },
      { id: 'b', ar: 'بَيْتٌ', fr: 'maison', emoji: '🏠', correct: true },
      { id: 'c', ar: 'قَلَمٌ', fr: 'stylo', emoji: '✏️', correct: false },
      { id: 'd', ar: 'نَهَرٌ', fr: 'rivière', emoji: '🏞️', correct: false },
    ]
  },

  {
    id: 'q9',
    type: 'localiser_son',
    niveau: 'Abjad',
    enonce: 'Dans quel mot trouves-tu la lettre س ?',
    lettre_cible: 'س',
    options: [
      { id: 'a', ar: 'كِتابٌ', fr: 'livre', emoji: '📖', correct: false },
      { id: 'b', ar: 'فَرَسٌ', fr: 'cheval', emoji: '🐎', correct: false },
      { id: 'c', ar: 'سَمَكٌ', fr: 'poisson', emoji: '🐟', correct: true },
      { id: 'd', ar: 'وَرْدَةٌ', fr: 'rose', emoji: '🌹', correct: false },
    ]
  },

  {
    id: 'q10',
    type: 'localiser_son',
    niveau: 'Abjad',
    enonce: 'Dans quel mot trouves-tu la lettre ي ?',
    lettre_cible: 'ي',
    options: [
      { id: 'a', ar: 'بابٌ', fr: 'porte', emoji: '🚪', correct: false },
      { id: 'b', ar: 'خَيْمَةٌ', fr: 'tente', emoji: '⛺', correct: true },
      { id: 'c', ar: 'رَمْلٌ', fr: 'sable', emoji: '🏖️', correct: false },
      { id: 'd', ar: 'جَمَلٌ', fr: 'chameau', emoji: '🐪', correct: false },
    ]
  },

  {
    id: 'q11',
    type: 'localiser_son',
    niveau: 'Abjad',
    enonce: 'Dans quel mot trouves-tu la lettre ح ?',
    lettre_cible: 'ح',
    options: [
      { id: 'a', ar: 'مَدْرَسَةٌ', fr: 'école', emoji: '🏫', correct: false },
      { id: 'b', ar: 'أَسَدٌ', fr: 'lion', emoji: '🦁', correct: false },
      { id: 'c', ar: 'نَخْلَةٌ', fr: 'palmier', emoji: '🌴', correct: false },
      { id: 'd', ar: 'حَمامَةٌ', fr: 'pigeon', emoji: '🕊️', correct: true },
    ]
  },

  // ── BLOC 3 : Compter les syllabes (4 questions) ───────────────

  {
    id: 'q12',
    type: 'compter_syllabes',
    niveau: 'Abjad',
    enonce: 'Combien de syllabes dans ce mot ?',
    mot: 'بَيْتٌ',
    mot_fr: 'maison',
    decomposition: ['بَيْ', 'تٌ'],
    options: [
      { id: 'a', val: 1, correct: false },
      { id: 'b', val: 2, correct: true },
      { id: 'c', val: 3, correct: false },
      { id: 'd', val: 4, correct: false },
    ]
  },

  {
    id: 'q13',
    type: 'compter_syllabes',
    niveau: 'Abjad',
    enonce: 'Combien de syllabes dans ce mot ?',
    mot: 'مَدْرَسَةٌ',
    mot_fr: 'école',
    decomposition: ['مَدْ', 'رَ', 'سَ', 'ةٌ'],
    options: [
      { id: 'a', val: 2, correct: false },
      { id: 'b', val: 3, correct: false },
      { id: 'c', val: 4, correct: true },
      { id: 'd', val: 5, correct: false },
    ]
  },

  {
    id: 'q14',
    type: 'compter_syllabes',
    niveau: 'Abjad',
    enonce: 'Combien de syllabes dans ce mot ?',
    mot: 'كِتابٌ',
    mot_fr: 'livre',
    decomposition: ['كِ', 'تا', 'بٌ'],
    options: [
      { id: 'a', val: 1, correct: false },
      { id: 'b', val: 2, correct: false },
      { id: 'c', val: 3, correct: true },
      { id: 'd', val: 4, correct: false },
    ]
  },

  {
    id: 'q15',
    type: 'compter_syllabes',
    niveau: 'Abjad',
    enonce: 'Combien de syllabes dans ce mot ?',
    mot: 'يَنْبوعٌ',
    mot_fr: 'source',
    decomposition: ['يَنْ', 'بو', 'عٌ'],
    options: [
      { id: 'a', val: 2, correct: false },
      { id: 'b', val: 3, correct: true },
      { id: 'c', val: 4, correct: false },
      { id: 'd', val: 5, correct: false },
    ]
  },

];

// ── Calcul du niveau selon le score ──────────────────────────────
export const calculerNiveau = (score, total = 15) => {
  const pct = (score / total) * 100;
  if (pct >= 80) return { niveau: 'Nur', emoji: '⭐', message: 'Excellent ! Tu peux passer au niveau Nur.' };
  if (pct >= 50) return { niveau: 'Abjad', emoji: '🌱', message: 'Tu maîtrises les bases. Continue avec le niveau Abjad.' };
  return { niveau: 'Abjad_debutant', emoji: '🌱', message: 'Commençons depuis le début avec les lettres arabes.' };
};

// ── Template vide pour autres niveaux (à compléter) ──────────────
export const QUESTIONS_TEMPLATE = {
  nur: [],      // À compléter quand supports Nur disponibles
  qalam: [],    // À compléter quand supports Qalam disponibles
  rawda: [],
  bayan: [],
};

export default QUESTIONS_ABJAD;
